import './_replies.scss';
import './_replies.dark-mode.scss';
import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Menu from './Menu';
import Toggle from './Toggle';

const Replies = ({ replies, onSelectReply }) => {
  const [open, setOpen] = useState();

  const onToggleClose = () => setOpen(!open);

  return (
    <div className="text-right mb-15">
      <Dropdown id="dropdown-replies" onToggle={onToggleClose} open={open} rootCloseEvent="click" pullRight>
        <Toggle bsRole="toggle">Custom toggle</Toggle>

        <Menu bsRole="menu" onToggleClose={onToggleClose} onSelectReply={onSelectReply} open={open} rootCloseEvent="click" replies={replies} />
      </Dropdown>
    </div>
  );
};

Replies.propTypes = {
  replies: PropTypes.array,
  onSelectReply: PropTypes.func,
};

export default Replies;
